import { takeEvery } from 'redux-saga/effects';
import { apiRequest } from './index';
import api from 'utils/api';
import * as organizationActions from 'actions/Organizations';
import history from 'utils/history';
import { Slide, toast } from 'react-toastify';
import { t } from 'i18n';
const getOrganizationList = apiRequest.bind(null, organizationActions.getOrganizationList, api.getOrganizationList);
const getActiveOrganizations = apiRequest.bind(
  null,
  organizationActions.getActiveOrganizations,
  api.getOrganizationList
);
const getInactiveOrganizations = apiRequest.bind(
  null,
  organizationActions.getInactiveOrganizations,
  api.getOrganizationList
);
const getOrganizationsHierarchy = apiRequest.bind(
  null,
  organizationActions.getOrganizationsHierarchy,
  api.getOrganizationsHierarchy
);
const getOrganization = apiRequest.bind(null, organizationActions.getOrganization, api.getOrganization);
const getChildOrganization = apiRequest.bind(null, organizationActions.getChildOrganization, api.getChildOrganization);
const getOrganizationTypes = apiRequest.bind(null, organizationActions.getOrganizationTypes, api.getOrganizationTypes);
const createOrganization = apiRequest.bind(null, organizationActions.createOrganization, api.createOrganization);
const updateOrganization = apiRequest.bind(null, organizationActions.updateOrganization, api.updateOrganization);

const updateOrganizationByAdmin = apiRequest.bind(
  null,
  organizationActions.updateOrganizationByAdmin,
  api.updateOrganizationByAdmin
);

const deleteOrganization = apiRequest.bind(null, organizationActions.deleteOrganization, api.deleteOrganization);

function* handleChangeOrganization(action) {
  if (action.payload.options === 'redirect') {
    return yield history.push('/organizations');
  } else {
    //remove all toast messages created by api-calls/page/... before displaying success message
    yield toast.dismiss();
    yield toast(t('messages.saved'), {
      transition: Slide,
      closeButton: true,
      autoClose: 2000,
      position: 'bottom-center',
      type: 'success',
    });
  }
}

function* handleCreateOrganizationSuccess(action) {
  if (action.payload.options === 'redirect') {
    return yield history.push('/organizations');
  } else {
    yield history.push(`/update-organization/${action.payload.id}`);

    const arg = { id: action.payload.id };

    yield apiRequest.apply(null, [organizationActions.getOrganization, api.getOrganization, arg]);

    //remove all toast messages created by api-calls/page/... before displaying success message
    yield toast.dismiss();
    yield toast(t('messages.saved'), {
      transition: Slide,
      closeButton: true,
      autoClose: 2000,
      position: 'bottom-center',
      type: 'success',
    });
  }
}

/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/

export function* watchGetOrganizationListRequest() {
  yield takeEvery(organizationActions.GET_ORGANIZATION_LIST.REQUEST, getOrganizationList);
}

export function* watchGetActiveOrganizationsRequest() {
  yield takeEvery(organizationActions.GET_ACTIVE_ORGANIZATIONS.REQUEST, getActiveOrganizations);
}

export function* watchGetInactiveOrganizationsRequest() {
  yield takeEvery(organizationActions.GET_INACTIVE_ORGANIZATIONS.REQUEST, getInactiveOrganizations);
}

export function* watchGetOrganizationsHierarchyRequest() {
  yield takeEvery(organizationActions.GET_ORGANIZATION_HIERARCHY.REQUEST, getOrganizationsHierarchy);
}

export function* watchGetOrganizationRequest() {
  yield takeEvery(organizationActions.GET_ORGANIZATION.REQUEST, getOrganization);
}

export function* watchCreateOrganizationRequest() {
  yield takeEvery(organizationActions.CREATE_ORGANIZATION.REQUEST, createOrganization);
}

export function* watchUpdateOrganizationRequest() {
  yield takeEvery(organizationActions.UPDATE_ORGANIZATION.REQUEST, updateOrganization);
}

export function* watchUpdateOrganizationByAdminRequest() {
  yield takeEvery(organizationActions.UPDATE_ORGANIZATION_BY_ADMIN.REQUEST, updateOrganizationByAdmin);
}

export function* watchUpdateOrganizationByAdminSuccess() {
  yield takeEvery(organizationActions.UPDATE_ORGANIZATION_BY_ADMIN.SUCCESS, handleChangeOrganization);
}

export function* watchDeleteOrganizationRequest() {
  yield takeEvery(organizationActions.DELETE_ORGANIZATION.REQUEST, deleteOrganization);
}

export function* watchDeleteOrganizationSuccess() {
  yield takeEvery(organizationActions.DELETE_ORGANIZATION.SUCCESS, getOrganizationList);
}

export function* watchCreateOrganizationSuccess() {
  yield takeEvery(organizationActions.CREATE_ORGANIZATION.SUCCESS, handleCreateOrganizationSuccess);
}

export function* watchUpdateOrganizationSuccess() {
  yield takeEvery(organizationActions.UPDATE_ORGANIZATION.SUCCESS, handleChangeOrganization);
}

export function* watchGetChildOranization() {
  yield takeEvery(organizationActions.GET_CHILD_ORGANIZATION.REQUEST, getChildOrganization);
}

export function* watchGetOrganizationTypes() {
  yield takeEvery(organizationActions.GET_ORGANIZATION_TYPES.REQUEST, getOrganizationTypes);
}
